import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "RiUM",
  style: {"width":"230px"}
}, null, -1)
const _hoisted_2 = { style: {"max-width":"340px","margin":"20px auto"} }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field -mt-2" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "grid align-items-center justify-content-between" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col py-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pl-2" }, "Need help?")
], -1)
const _hoisted_9 = { class: "col py-0 flex-none" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "grid align-items-center justify-content-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col py-0" }, null, -1)
const _hoisted_13 = { class: "col flex-none py-0" }
const _hoisted_14 = { class: "field text-center" }
const _hoisted_15 = { class: "field text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Register = _resolveComponent("Register")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.show,
      closable: false,
      title: "Login"
    }, {
      beforeHeader: _withCtx(() => [
        _hoisted_1
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              type: "text",
              class: "p-inputtext-lg w-full",
              placeholder: "Enter your Email"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_InputPassword, {
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              class: "p-inputtext-lg w-full",
              feedback: false,
              "toggle-mask": "",
              placeholder: "Password"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              href: "#",
              class: "link text-color-gray pl-2",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
            }, "( Forgot password? )")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_IconTextBlock, {
                  icon: "icon-mobile-2",
                  "icon-color": true,
                  label: _ctx.location.phone_number,
                  href: `tel:${_ctx.location.phone_number}`,
                  class: "iconTextBlock--icon-lg"
                }, null, 8, ["label", "href"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_IconTextBlock, {
                    icon: "icon-envelope-4",
                    "icon-color": true,
                    label: _ctx.location.email,
                    href: `mailto:${_ctx.location.email}`,
                    class: "iconTextBlock--icon-lg"
                  }, null, 8, ["label", "href"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              label: "Login",
              class: "minWidth",
              onClick: _ctx.onClickLogin
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", null, [
              _createTextVNode(" Don't have an account yet?"),
              _hoisted_16,
              _createElementVNode("a", {
                href: "#",
                class: "link text-color-blue",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {
                _ctx.close();
                _ctx.register = true;
              }, ["prevent"]))
              }, "Create an account.")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Register, {
      show: _ctx.register,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.register = false))
    }, null, 8, ["show"])
  ], 64))
}